import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { Text } from 'components/Text';
import './Icon.scss';
/**
 * @component Icon
 * @since 1.0.0
 */
export function Icon(props) {
    const { style, tooltip, value } = Object.assign({ style: 'normal' }, props);
    if (value == null) {
        return null;
    }
    if (typeof value == 'string') {
        let type = 'far';
        let name = 'bug';
        const rules = value.split(/\s+/);
        if (rules.length == 2) {
            for (const rule of rules) {
                if (rule == 'fas' || rule == 'far' || rule == 'fad' || rule == 'fal') {
                    type = rule;
                }
                else {
                    name = rule;
                }
            }
        }
        else {
            name = value;
        }
        name = 'fa-' + name;
        const className = classNames('icon', 'icon--' + style, { 'icon--with-tooltip': tooltip }, props.className, type, name);
        return (React.createElement("div", { className: className, onClick: props.onClick }, tooltip && React.createElement(Text, { className: "icon-tooltip-value", value: tooltip })));
    }
    const className = classNames('icon', 'icon--' + style, props.className, {
        'icon--with-tooltip': tooltip
    });
    return (React.createElement("div", { className: className, onClick: props.onClick },
        value,
        tooltip && React.createElement(Text, { className: "icon-tooltip-value", value: tooltip })));
}
